import { HeartIcon } from '@syconium/little-miss-figgy'

import { NavTab } from '../../../types/graphql/site-fixtures'

export function useFavoritesTab(): NavTab | null {
  return {
    __typename: 'NavTab',
    ariaLabel: 'Favorites',
    href: '/favorites',
    id: 'favorites',
    render: () => {
      return <HeartIcon />
    },
    sections: [],
    text: '',
    textColor: null,
    wrapperElement: undefined,
    alternateModelVariant: null,
  }
}
